// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:24:58

export default {
  "id": "broken-city-combat",
  "slug": "broken-city-combat",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/853eef516499417e90429335d0a33ca3-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/853eef516499417e90429335d0a33ca3/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Broken City Combat",
      "description": "Immerse yourself in the chaotic battleground of Broken City Combat, a fast-paced FPS set in a desolate urban warzone. As the city crumbles under relentless attacks, you are tasked with surviving the brutal onslaught while rescuing survivors and taking down ruthless enemies. Navigate through abandoned streets, derelict buildings, and multi-floor complexes, each filled with challenges and surprises.",
      "instructions": "- Left Mouse to Shot\n- Right Mouse button for Scope \n- E to Pick UP\n- 1,2,3,4,5 to change weapon ",
      "genres": [
        "Shooter"
      ],
      "tags": [
        "rescue",
        "shoot-em-up"
      ]
    },
    "zh-CN": {
      "title": "破碎之城战斗",
      "description": "沉浸于混乱的破碎城市战场，这是一款设定在荒凉城市战区的快节奏第一人称射击游戏。随着城市在无休止的攻击下崩塌，你将面临艰难的生存挑战，同时救援幸存者并击败残忍的敌人。穿梭于废弃街道、破败建筑和多层复合体，每个地方都充满挑战和惊喜。",
      "instructions": "- 左键射击\n- 右键使用瞄准镜\n- E键拾取\n- 1、2、3、4、5键切换武器",
      "genres": [
        "射击游戏"
      ],
      "tags": [
        "救援",
        "射击类"
      ]
    },
    "zh-TW": {
      "title": "破碎都市戰鬥",
      "description": "沉浸於亂無章法的斷裂城市戰鬥場景，一場設置在荒涼都市戰區的快節奏第一人稱射擊遊戲。隨著城市在無情攻擊下崩潰，你被任務於在殘酷的襲擊中生存，救援生還者並擊敗無情敵人。穿梭於荒廢的街道、破舊的大樓和多层複合建築，每個地方都充滿挑戰和驚喜。",
      "instructions": "- 左鍵射擊\n- 右鍵切換至瞄准鏡\n- 按「E」拾取\n- 按鍵「1,2,3,4,5」切換武器",
      "genres": [
        "射手"
      ],
      "tags": [
        "救援",
        "射擊遊戲"
      ]
    },
    "zh-HK": {
      "title": "破城戰鬥",
      "description": "投身於混亂的戰場破損城市作戰，一款設置在荒涼城市戰區的高速第一人稱射擊遊戲。隨著城市在無情攻擊下崩塌，你被赋予任務在生存於凶猛攻擊的同時救援倖存者及擊敗無情的敵人。穿梭於荒蕪的街道、棄置的大樓及多層複合體，每個地方都充滿挑戰和驚喜。",
      "instructions": "- 左鍵射擊\n- 右鍵按鈕用於放大鏡\n- 按「E」拾取\n- 1、2、3、4、5 鍵切換武器",
      "genres": [
        "射擊遊戲"
      ],
      "tags": [
        "拯救",
        "射擊遊戲"
      ]
    },
    "ja": {
      "title": "破壊都市戦闘",
      "description": "破壊された都市の混沌とした戦場に身を投じ、荒廃した都市戦場で展開される高速なFPS「Broken City Combat」を楽しみましょう。都市が絶え間なく攻撃を受けながら崩れ落ちる中、あなたは残忍な攻撃を生き延びつつ生存者を救出し、無情な敵を倒す任務にいます。放棄された通り、荒廃したビル、多層の複合施設を進みながら、それぞれが挑戦と驚きに満ちています。",
      "instructions": "- 左クリックで発射\n- 右クリックで照準\n- Eキーで拾う\n- 1、2、3、4、5で武器を切り替える",
      "genres": [
        "シューティングゲーム"
      ],
      "tags": [
        "救援",
        "シューティングゲーム"
      ]
    },
    "ko": {
      "title": "파괴된 도시 전투",
      "description": "Broken City Combat의 혼란스러운 전장에 몰입하세요. 이 빠른 템포의 FPS는 황폐한 도시 전쟁지대에서发生합니다. 도시가 끊임없는 공격에 의해 붕괴되고 있을 때, 당신은 무자비한 공격을 견딘 동시에 생존자를 구출하고 무자비한 적을 물리치는 임무를 맡게 됩니다. 버려진 거리, 무너진 건물, 다층 복합 건물을 통해 탐험하며, 각각이 도전과 놀라운 사건들이 가득 차 있습니다.",
      "instructions": "- 왼쪽 마우스 버튼을 사용하여 발사\n- 오른쪽 마우스 버튼을 사용하여 시야 조절\n- E 키를 눌러서 수집\n- 1, 2, 3, 4, 5 키를 눌러서 무기를 변경",
      "genres": [
        "射手"
      ],
      "tags": [
        "구조",
        "쏘아라 게임"
      ]
    },
    "fr": {
      "title": "Combats dans une ville brisée",
      "description": "Immergez-vous dans le chaos de la bataille urbaine désolée de Broken City Combat, un FPS rapide se déroulant dans un champ de bataille urbain en ruines. Alors que la ville s'effondre sous des attaques ininterrompues, vous devez survivre à l'assaut brutal tout en secourant les survivants et en abattant les ennemis sans pitié. Parcourez les rues abandonnées, les bâtiments en ruines et les complexes à plusieurs étages, chacun regorgeant de défis et de surprises.",
      "instructions": "- Clic gauche pour tirer\n- Bouton droit de la souris pour l'optique\n- E pour ramasser\n- 1, 2, 3, 4, 5 pour changer d'arme",
      "genres": [
        "Tirailleur d'élite"
      ],
      "tags": [
        "Sauvetage",
        "tire-l'œil"
      ]
    }
  }
};
